var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"done-text",class:{ 'is-active': _vm.done }},[_c('span',{staticClass:"done-text__base"},[_vm._t("default")],2),_c('span',{staticClass:"done-text__done"},[_vm._t("done",function(){return [_c('BaseIcon',{attrs:{"glyph":"done"}}),_vm._v(" "+_vm._s(_vm.text))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }